module.exports = __webpack_public_path__ + "static/media/AboutUsPage.3722f7e7.jpeg";